module.exports = __webpack_public_path__ + "static/social-candia-cover-ede219d76c7bac8fad6f5849b5f0af77.png";